import { render, staticRenderFns } from "./ScoreManagement.vue?vue&type=template&id=4e3d2a4b&scoped=true&"
import script from "./ScoreManagement.vue?vue&type=script&lang=js&"
export * from "./ScoreManagement.vue?vue&type=script&lang=js&"
import style0 from "./ScoreManagement.vue?vue&type=style&index=0&id=4e3d2a4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3d2a4b",
  null
  
)

export default component.exports